import React from 'react';
import '../css/App.css';
import '../css/Product.css';
import ls from 'local-storage'
import {withRouter} from "react-router";
class Products extends React.Component{
    list =[];
    constructor(props){
        super(props);
        this.state = {
            products: [],
            buy_list: [],
        };
    }
    componentWillReceiveProps(props) {
        this.setState(
            {
                products:props.products,
            });

    }
    componentDidMount = () => {
        if(ls.get("list"))
            this.list = ls.get("list");
        if(this.list  != null && this.list.length > 0)
            this.setState({buy_list:this.list});
    };

    render() {
        return (
            <div id={"products"} >
                {this.state.products.map((product)=>{
                    let price_with_discout = "";
                    let discount_label = "";
                    let close_btn = "";
                    let buy_btn = "";
                    if(product.product_discounts > 0){
                        price_with_discout = (<div className={"product_price"}>{new Intl.NumberFormat("fa").format(product.product_price)}</div>);
                        discount_label = (<div className={"product_discount_label"}>%{Math.round((product.product_discounts/product.product_price)*100)} تخفیف</div>)
                    }


                    if(product.product_number == -1)
                        buy_btn = (<button className={"btn_close"}>بسته است</button>)
                    else if(product.product_number == 0)
                        buy_btn = (<button className={"btn_close"}>تمام شد</button>)
                    else if(!this.list.some(el=>el.product_id === product.product_id)) {
                        buy_btn = (<button className={"btn_buy"} onClick={()=>this.addProductToList(product.product_id)} > خرید </button>)
                    }
                    else{
                        let index = this.list.findIndex((cart=>cart.product_id === product.product_id));
                        buy_btn = (
                            <div className={"buyDiv"}>
                                {/*<button className={"add_amount"}  onClick={()=>this.addProductToList(product.product_id)}>+</button>
                                <label className={"amount"}>{this.state.buy_list[index].product_number + this.getProductUnit(product.product_unit)}</label>
                                <button className={"sub_amount"}  onClick={()=>this.subProductToList(product.product_id)} >-</button> */}
                                <div className={"add_amount"}  onClick={()=>this.addProductToList(product.product_id)}><i className={"glyphicon glyphicon-plus "}/> </div>
                                <label className={"amount"}>{this.state.buy_list[index].product_number + this.getProductUnit(product.product_unit)}</label>
                                <div className={"sub_amount"}  onClick={()=>this.subProductToList(product.product_id)} ><i className={"glyphicon glyphicon-minus "}/> </div>
                            </div>
                        )
                    }
                    let store_name = (<div className={"product_store_name"}>{product.store_name}</div>);
                    if(this.props.showStoreName == false)
                        store_name="";
                    return (
                        <div className={"productItem"} onClick={(e)=>this.handleProductClick(e,product.product_id)}>
                            <div className={"product_image_box"}> {discount_label} <img className={"product_image"} src={product.product_image}/></div>
                            <div className={"product_price_discount"}>{new Intl.NumberFormat("fa").format((product.product_price - product.product_discounts))} تومان{price_with_discout}</div>
                            <br/>
                            <div className={"product_name"}>{product.product_name}</div>
                            {store_name}
                            {buy_btn}
                        </div>
                    )
                })}
            </div>
        )
    }
    addProductToList=(id)=>{
        if(this.list  == null)
            this.list  = [];
        let found = this.list.some(el=>el.product_id === id);
        let productIndex = this.state.products.findIndex(product=>product.product_id === id);
        let product_number = this.state.products[productIndex].product_number;
        if(!found){
            let clone = Object.assign({},this.state.products[productIndex]);
            this.list.push(clone);
            this.list[this.list.length-1].product_number = 1;
            this.list[this.list.length-1].product_max_number = product_number;
        }
        else{
            let index = this.list.findIndex((cart=>cart.product_id === id));
            if(product_number == null || product_number > this.list[index].product_number)
                this.list[index].product_number +=1;
        }

        ls.set("list",this.list);
        this.setState({buy_list:this.list});
    };
    subProductToList(id){
        let found = this.list.some(el=>el.product_id === id);
        if(found){
            let index = this.list.findIndex((cart=>cart.product_id === id));
            this.list[index].product_number -=1;
            if(this.list[index].product_number <= 0)
                this.list.splice(index,1);
        }

        ls.set("list",this.list);
        this.setState({buy_list:this.list});
    }

    handleProductClick(e,id) {
        if(e.target && (e.target.className == "add_amount" || e.target.className == "sub_amount" || e.target.className == "btn_buy"|| e.target.className == "amount"|| e.target.className.includes("glyphicon")))
            return;
        ls.set("product_id",id);
        this.props.history.push("/product");
    }
    getProductUnit(unit){
        switch (unit) {
            case 'gram':return" گرم";
            case 'kg':return" کیلوگرم";
            case 'nimkilo':return" نیم کیلو";
            case 'number':return" عدد";
            case 'pors':return" پرس";
            default:return " عدد";
        }
    }
}

export default withRouter(Products);
